"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentTypes = void 0;
var MomentTypes = {
  USER: 'USER',
  PORTAL: 'PORTAL',
  MOMENT: 'MOMENT'
};
exports.MomentTypes = MomentTypes;